export default __webpack_public_path__ + "static/Harmonized-f3edf324b2863b0ac1b3803c4a92481b.webm";